import { render, staticRenderFns } from "./SitchDevices.vue?vue&type=template&id=51809018&scoped=true&"
import script from "./SitchDevices.vue?vue&type=script&lang=ts&"
export * from "./SitchDevices.vue?vue&type=script&lang=ts&"
import style0 from "./SitchDevices.vue?vue&type=style&index=0&id=51809018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51809018",
  null
  
)

export default component.exports